export enum FastqQcStatus {
    QC_PASSED = 'QcPassed',
    QC_FAILED = 'QcFailed',
}

export const NON_SUCCESS_FASTQ_QC_STATUSES = [FastqQcStatus.QC_FAILED];
export const ALL_POSSIBLE_FASTQ_QC_STATUSES = [FastqQcStatus.QC_PASSED.toString(), FastqQcStatus.QC_FAILED.toString()];

